/** Vyberte hráče */
export const LOC_KEY_CHOOSE_PARTICIPANTS = "GUI-776344";
/** Odznačit vše */
export const LOC_KEY_UNCHECK_ALL = "GUI-776363";
/** Označit vše */
export const LOC_KEY_CHECK_ALL = "GUI-771537";
/** Zobrazit uživatele role */
export const LOC_KEY_DISPLAY_USERS_OF_ROLE = "GUI-771538";
/** Schovat uživatele rolí */
export const LOC_KEY_HIDE_USERS_ROLE = "GUI-782122";
/** Zrušit */
export const LOC_KEY_CANCEL = "GUI-33412";
/** Vybrat */
export const LOC_KEY_CHOOSE = "GUI-311684";

export const STATIC_LOC_KEYS = [
    LOC_KEY_CHOOSE_PARTICIPANTS,
    LOC_KEY_UNCHECK_ALL,
    LOC_KEY_CHECK_ALL,
    LOC_KEY_DISPLAY_USERS_OF_ROLE,
    LOC_KEY_HIDE_USERS_ROLE,
    LOC_KEY_CANCEL,
    LOC_KEY_CHOOSE,
];
